.container {
    background: var(--info-bg);
    display: flex;
    justify-content: center;
    height: 100%;
    position: relative;
    overflow: hidden;
    --slide-offset: 30px;
}

.progress-bar-container {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: var(--info-bg);
    border-radius: 1px;
    overflow: hidden;
    z-index: 10;
    animation: slideDown 0.6s ease-out;
}

.content {
    top: 25%;
    height: fit-content;
    position: relative;
    text-align: center;
    padding: 0 32px;
    animation: slideDown 0.6s ease-out;
}

.scenery {
    overflow: hidden;
    position: absolute;
    /* Not sure why this is needed, but it's not butting against the bottom
    otherwise */
    bottom: -4px;
    left: 0;
    right: 0;
    animation: slideUp 0.6s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(calc(-1 * var(--slide-offset)));
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(var(--slide-offset));
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
